/**
 * Roles that may open a user profile (/users/:id, /edit, /logs). The routes and
 * UserProfileLink both read this list, so a link is never offered for a page the
 * route would bounce.
 *
 * UI roles (transformUserRole): CompanyAdministrator and OfficeAdministrator are
 * non-SaaS; ServiceAdmin and ServiceCoach are their SaaS (admin-elevated) forms.
 */
export const USER_PROFILE_ROLES = [
  "Administrator",
  "CompanyAdministrator",
  "ServiceAdmin",
  "ContractorAdministrator"
];

/**
 * S3DEV2-7730: the backend shows another user's profile only when that user's
 * company is in the caller's company scope (S3DEV2-7821). A non-SaaS company
 * administrator's scope does not include S3, so where the linked user is an S3
 * coach or staff member (patient and order pages) they would only get a refusal.
 */
const S3_STAFF_PROFILE_ROLES = USER_PROFILE_ROLES.filter(
  role => role !== "CompanyAdministrator"
);

export const canOpenUserProfile = (userRole, { linkedUserIsS3Staff = false } = {}) =>
  (linkedUserIsS3Staff ? S3_STAFF_PROFILE_ROLES : USER_PROFILE_ROLES).includes(userRole);
